import { useQuery } from '@tanstack/react-query';
import { apiFetch } from './api';

export interface GitaTranslation {
  author_id: number;
  author_name: string;
  description: string;
}

export interface GitaVerse {
  chapter: number;
  verse: number;
  text: string;
  transliteration: string;
  word_meanings: string;
  translations: GitaTranslation[];
  commentaries: GitaTranslation[];
}

export function useRandomGitaVerse() {
  return useQuery<GitaVerse>({
    queryKey: ['gita', 'random'],
    queryFn: () => apiFetch<GitaVerse>('/api/gita/random'),
    staleTime: Infinity, // Keep the generated random verse stable during the session. Switch logic will refetch if needed.
    refetchOnWindowFocus: false,
  });
}
